<div class="confirm-dialog">
  <p class="confirm-dialog__kicker">Please confirm</p>
  <p class="confirm-dialog__message">{{ message }}</p>
  <div class="confirm-dialog__actions">
    <button
      type="button"
      class="confirm-dialog__btn confirm-dialog__btn--ghost"
      (click)="onCancel()">
      {{ cancelButtonText }}
    </button>
    <button
      type="button"
      class="confirm-dialog__btn"
      [class.confirm-dialog__btn--gold]="!isDanger"
      [class.confirm-dialog__btn--danger]="isDanger"
      (click)="onConfirmClick()">
      {{ confirmButtonText }}
    </button>
  </div>
</div>
